/** @format */

import {Trans} from 'react-i18next';

import {ArrowOutwardOutlined} from '@mui/icons-material';

import theme from 'theme';

import {Container, Content, Root} from './styles';

interface Props {
  bgColor: string;
  onClick: () => void;
}

const WidgetSettingsButton = ({bgColor, onClick}: Props) => {
  return (
    <Root onClick={onClick}>
      <Container bgColor={bgColor} />
      <Content>
        <ArrowOutwardOutlined sx={{fontSize: '16px', margin: theme.spacing(0, 0.5, 0.5, 0)}} />
        <Trans>Настроить</Trans>
      </Content>
    </Root>
  );
};

export {WidgetSettingsButton};
